module.exports = __webpack_public_path__ + "static/img/circle_2.cc4f269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle_2.png
// module id = rp3j
// module chunks = 1